import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "./preview.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";
import { FaChevronLeft } from "react-icons/fa";
import { FaMinus, FaPlus } from "react-icons/fa6";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useCart } from "../CartContext/CartContext";
import { IoMdCart } from "react-icons/io";
import { GrMoney } from "react-icons/gr"
import getImageUrl from "../../utils/getImageUrl";

const Preview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const productId = location.state?.product;
  const isLoggedIn = localStorage.getItem("token");
  const { addToCart, cartItems } = useCart();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [product, setProduct] = useState(null);
  const [selectedAroma, setSelectedAroma] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [activeTab, setActiveTab] = useState("Description");
const [openAccordion, setOpenAccordion] = useState(null);

  

  const CustomPrevArrow = (props) => (
    <div className="custom-arrow custom-prev" onClick={props.onClick}>
      <FaChevronLeft size={30} color="white" />
    </div>
  );

  const CustomNextArrow = (props) => (
    <div className="custom-arrow custom-next" onClick={props.onClick}>
      <FaChevronRight size={30} color="white" />
    </div>
  );

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await fetch(
          `/api/preview/products/${productId}`
        );
        if (!response.ok) throw new Error("Product not found");
        const data = await response.json();
        setProduct(data);
        setSelectedAroma(data.aromas[0]);
        setSelectedSize(data.aromas[0].sizes[0]);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    if (productId) fetchProduct();
    else {
      setError("Product ID not provided");
      setLoading(false);
    }
  }, [productId]);

  const handleAromaChange = (aroma) => {
    setSelectedAroma(aroma);
    setSelectedSize(aroma.sizes[0]);
    setQuantity(1);
  };

  const handleSizeChange = (size) => {
    setSelectedSize(size);
    setQuantity(1);
  };

  const getAlreadyInCartQuantity = () => {
    const existingItem = cartItems.find(
      (item) =>
        item.productId === product.productId &&
        item.sizeId === selectedSize.sizeId
    );
    return existingItem ? existingItem.quantity : 0;
  };

const handleAddToCart = () => {
  if (!selectedSize) return;

  const alreadyInCartQty = getAlreadyInCartQuantity();
  const total = quantity + alreadyInCartQty;

  if (selectedSize.quantity === 0 || total > selectedSize.quantity) return;

  const cartItem = {
    id: product._id.$oid,
    productId: product.productId,
    productName: product.productName,
    aroma: selectedAroma.name,
    size: `${selectedSize.size}${selectedSize.unit}`,
    unit: selectedSize.unit,
    sizeId: selectedSize.sizeId,
    price: selectedSize.sellingPrice,
    quantity,
    image: selectedAroma.images[0],
  };

  addToCart(cartItem);
  navigate("/cart");
};

  const handleBuyNow = () => {
  if (!selectedSize) return;

  const alreadyInCartQty = getAlreadyInCartQuantity();
  const total = quantity + alreadyInCartQty;

  if (selectedSize.quantity === 0 || total > selectedSize.quantity) return;

  const cartItem = {
    id: product._id.$oid,
    productId: product.productId,
    productName: product.productName,
    aroma: selectedAroma.name,
    size: `${selectedSize.size}${selectedSize.unit}`,
    unit: selectedSize.unit,
    sizeId: selectedSize.sizeId,
    price: selectedSize.sellingPrice,
    quantity,
    image: selectedAroma.images[0],
  };

  addToCart(cartItem);
  isLoggedIn ? navigate("/checkout") : navigate("/login", { state: { from: "/checkout" } });
};


  const increaseQuantity = () => {
    setQuantity((prev) =>
      prev < selectedSize.quantity ? prev + 1 : prev
    );
  };

  const decreaseQuantity = () => {
    setQuantity((prev) => (prev > 1 ? prev - 1 : prev));
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!product) return <div className="error">Product not found</div>;

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
  };
  
    return (
        <>
            <div className="breadcrumb-wrap bg-f br-2 ">
                <div className="container" style={{marginBottom:'-90px'}}>
                    <div className="breadcrumb-title" style={{ padding: "0" }}>
                    </div>
                </div>
            </div>
            {/* <div className="preview-container">
            
            <div className="d-flex row previewcontiner">
                <div className="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-1">
                    
                    <div className="imageslider">
                        <Slider {...sliderSettings}>
                            {selectedAroma.images.map((img, index) => (
                                <div key={index}>
                                    <img
                                        src={getImageUrl(img)}
                                        alt={`Product ${index + 1}`}
                                        style={{ width: '100%', height: '65vh', objectFit: 'contain' }}
                                    />
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>

                <div className="col-xl-6 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
                    <div >
                    
                        <div className="product-detail">
                            <h1 className="productname">{product.productName}</h1>
                            <div className="productprice">
                                <div className="sellingprice">Rs.{selectedSize.sellingPrice}</div>
                                <div className="originalprice">MRP: Rs.{selectedSize.price}</div>
                            </div><h6 style={{ margin: "2%" }}>(Incl. of all taxes)</h6>
                            <div className="discount">
                                {selectedSize.offer}% OFF
                            </div>

                            <div className="productcap">{product.caption}</div>

                            <div className="aroma">
                                <strong>Fragrances:</strong><br />
                                <div style={{ display: "flex", gap: "10px",flexWrap:"wrap" }}>
                                    {product.aromas.map((aroma) => (
                                        <button
                                            key={aroma}
                                            className="aromaname"
                                            onClick={() => handleAromaChange(aroma)}
                                            style={{
                                                backgroundColor: selectedAroma === aroma ? "#14467b" : "#fff",
                                                color: selectedAroma === aroma ? "#fff" : "#000",
                                            }}
                                        >
                                            {aroma.name}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {selectedSize.quantity < 5 && (
                                <p style={{ marginTop: "10px", color: "red" }}>
                                    <strong>Limited Stock:</strong> {selectedSize.quantity} left
                                </p>
                            )}

                            <div className="ProductSizes">
                                <strong>Size</strong>
                                <div style={{ display: "flex", gap: "10px" }}>
                                    {selectedAroma.sizes.map((size) => (
                                        <button
                                            className="sizelist"
                                            key={size}
                                            onClick={() => handleSizeChange(size)}
                                            style={{
                                                backgroundColor: selectedSize === size ? "#14467b" : "#fff",
                                                color: selectedSize === size ? "#fff" : "#000",
                                            }}
                                        >
                                            {size.size} {size.unit}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div className="d-flex gap-3 buybuttons">
                                <div className="quantityselector">
                                    <button className="minusbutton" onClick={decreaseQuantity}><FaMinus /></button>
                                    <span className="productquantity">{quantity}</span>
                                    <button className="plusbutton" onClick={increaseQuantity}><FaPlus /></button>
                                </div>
                                <div className="previewaddtocart">
                                    <button className="previewaddtocartbutton" onClick={handleAddToCart}>ADD TO CART</button>
                                </div>
                                <div className="buynow">
                                    <button className="buynowbutton" onClick={handleBuyNow}>BUY NOW</button>
                                </div>
                            </div>
                        </div>
                        <div className="preproductdesc">
                            <div>
                                <h4>Description</h4>
                                <p>{product.description}</p>

                            </div>
                            <div >
                                <h4>Uses</h4>
                                {product.uses && (<p>{product.uses}</p>)}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
<br/>
            <Link to={"/products"} className="backtoproduct" ><FaArrowLeft />Back to list</Link>
        </div> */}

            <div className="preview-container">
                <div className="d-flex row  previewcontiner">
                    <div className="col-xl-1 order-1"></div>
                    <div className="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
                        <div className="imageslider">
                            <div className="discount_price_container">
                                <h6 style={{ color: "white", marginTop: "4px" }} className="new_karthik_heading_here">{selectedSize.offer}% OFF</h6>
                            </div>
                            
                            <Slider {...sliderSettings} >
                                {selectedAroma.images.map((img, index) => (
                                    <div key={index}>
                                        
                                        <img
                                            src={getImageUrl(img)}
                                            alt={`Product ${index + 1}`}
                                            style={{
                                                width: "100%",
                                                height: "65vh",
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                ))}
                            </Slider>

                        </div>
                    </div>

                    <div className="col-xl-6 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-3">
                        <div>
                            
                            <div className="product_detail_new_karthik">
                                
                                <div className="new_karthik_product_container">
                                    <div>
                                        <p style={{color:"black"}}>{product.caption}</p>
                                        <h4>{product.productName}</h4>
                                    </div>

                                    <div >
                                        
                                        <div className="include_container">
                                            <h4 className="heading_karthik_new_size_sellingprice new_karthik_heading_here">₹{selectedSize.sellingPrice}.00 <span className="include_text">(Incl. of all taxes)</span></h4>
                                        </div>
                                        <h4 className="heading_karthik_new_size new_karthik_heading_here" >MRP ₹{selectedSize.price}.00</h4>
                                    </div>
                                </div>

                                <div className="ProductSizes">
                                    <h6 style={{ textAlign: "start" }}>Fragrances:</h6>

                                    <div
                                        style={{ display: "flex", gap: "10px" }}
                                    >
                                        {product.aromas.map((aroma) => (
                                            <button
                                                key={aroma}
                                                className="sizelist"
                                                onClick={() => handleAromaChange(aroma)}
                                                style={{
                                                    backgroundColor:
                                                        selectedAroma === aroma ? "#483393  " : "#fff",
                                                    color: selectedAroma === aroma ? "#fff" : "#000",
                                                }}
                                            >
                                                {aroma.name}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                <div className="ProductSizes">
                                    <h6 style={{ textAlign: "start" }}>Size</h6>
                                    <div style={{ display: "flex", gap: "10px" }}>
                                        {selectedAroma.sizes.map((size) => (
                                            <button
                                                className="sizelist new_karthik_heading_here"
                                                key={size}
                                                onClick={() => handleSizeChange(size)}
                                                style={{
                                                    backgroundColor:
                                                        selectedSize === size ? "#483393" : "#fff",
                                                    color: selectedSize === size ? "#fff" : "#000",
                                                }}
                                            >
                                                {size.size} {size.unit}
                                            </button>
                                        ))}
                                    </div>
                                    {selectedSize.quantity === 0 && (
    <p style={{ color: "red", fontWeight: "bold" }}>Out of Stock</p>
  )}

                
                 
                                </div>

                                <div className="karthik_new_purchanse_product">
                                    <div className="quantityselector">
                                        <button className="minusbutton" onClick={decreaseQuantity}>
                                            <FaMinus />
                                        </button>
                                        <span className="productquantity">{quantity}</span>
                                        <button className="plusbutton" onClick={increaseQuantity}>
                                            <FaPlus />
                                        </button>
                                    </div>

                                 <button
  className="button_redesign"
  onClick={handleAddToCart}
  disabled={selectedSize.quantity === 0}
  style={{ opacity: selectedSize.quantity === 0 ? 0.5 : 1 }}
>
  Add To Cart &nbsp;<IoMdCart />
</button>

<button
  className="button_redesign"
  onClick={handleBuyNow}
  disabled={selectedSize.quantity === 0}
  style={{ opacity: selectedSize.quantity === 0 ? 0.5 : 1 }}
>
  Buy Now &nbsp;<GrMoney />
</button>

                                </div>
                                <hr />
                               <div className="product-info-tabs">
  {/* Product Detail Tabs and Accordion */}
<div className="product-info-section">
  {/* Tabs (Desktop) */}
  <div className="tab-buttons d-none d-md-flex">
    {["Description", "Uses", "Key Features", "Ingredients", "How to Use", "Customer Reviews"].map((tab, index) => (
      <button
        key={index}
        className={`tab-btn ${activeTab === tab ? "active" : ""}`}
        onClick={() => setActiveTab(tab)}
      >
        {tab}
      </button>
    ))}
  </div>

  <div className="tab-content d-none d-md-block mt-2">
    {activeTab === "Description" && <p>{product.description}</p>}
    {activeTab === "Uses" && <p>{product.uses}</p>}
    {activeTab === "Key Features" && <p>{product.keyFeatures}</p>}
    {activeTab === "Ingredients" && <p>{product.ingredients}</p>}
   {activeTab === "How to Use" && (
  <p
    dangerouslySetInnerHTML={{
      __html: product.howToUse.replace(/\n/g, "<br/>"),
    }}
  />
)}

    {activeTab === "Customer Reviews" && <p>{product.customerReviews}</p>}
  </div>

  {/* Accordion (Mobile) */}
  <div className="accordion-container d-md-none mt-3">
    {[
      { title: "Description", content: product.description?.replace(/\n/g, "<br/>")},
      { title: "Uses", content: product.uses?.replace(/\n/g, "<br/>") },
      { title: "Key Features", content: product.keyFeatures?.replace(/\n/g, "<br/>") },
      { title: "Ingredients", content: product.ingredients?.replace(/\n/g, "<br/>") },
{
  title: "How to Use",
  content: product.howToUse?.replace(/\n/g, "<br/>"),
},

      { title: "Customer Reviews", content: product.customerReviews?.replace(/\n/g, "<br/>") },
    ].map((section, index) => (
      <div key={index} className="accordion-item">
        <button
          className="accordion-title"
          onClick={() =>
            setOpenAccordion(openAccordion === index ? null : index)
          }
        >
          {section.title}
        </button>
        {openAccordion === index && (
          <div className="accordion-content">
            <p>{section.content}</p>
          </div>
        )}
      </div>
    ))}
  </div>
</div>

</div>

                            </div>
                        </div>
                    </div>
                    <div className="col-xl-1 order-4">
                        
                    </div>
                </div>

                <br />
                <Link to={"/products"} className="backtoproduct">
                    <FaArrowLeft /> &nbsp;
                    Back to List
                    
                </Link>
                
            </div>
        </>
    );
};

export default Preview;